import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, XCircle } from 'lucide-react';
const forYou = ['Mujeres de más de 35 años que sienten su metabolismo "lento"', 'Profesionales con alto estrés que sufren de inflamación abdominal por la tarde', 'Personas que necesitan un resultado visible y rápido para recuperar la confianza', 'Quienes buscan un método natural sin suplementos raros ni químicos'];
const notForYou = ['Buscas una solución mágica para perder 10kg de grasa en dos días', 'No estás dispuesta a seguir un orden específico de comidas por 48 horas', 'Eres menor de edad o tienes trastornos de la conducta alimentaria'];
export function AudienceSection() {
  return <section className="py-16 md:py-24 px-6" data-id="element-1">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-8" data-id="element-2">
        {/* For You */}
        <FadeIn direction="right" data-id="element-3">
          <div className="bg-white p-8 rounded-3xl shadow-sm border border-sage/20 h-full" data-id="element-4">
            <h3 className="text-2xl font-bold mb-8 text-charcoal flex items-center gap-3" data-id="element-5">
              <span className="bg-sage/20 p-2 rounded-full" data-id="element-6">
                <Check className="w-6 h-6 text-sage" data-id="element-7" />
              </span>
              Esto es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-8">
              {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-9">
                  <Check className="w-5 h-5 text-sage flex-shrink-0 mt-1" data-id="element-10" />
                  <span className="text-warmgray" data-id="element-11">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        {/* Not For You */}
        <FadeIn direction="left" delay={0.2} data-id="element-12">
          <div className="bg-cream p-8 rounded-3xl border border-terracotta/10 h-full" data-id="element-13">
            <h3 className="text-2xl font-bold mb-8 text-charcoal flex items-center gap-3" data-id="element-14">
              <span className="bg-terracotta/10 p-2 rounded-full" data-id="element-15">
                <XCircle className="w-6 h-6 text-terracotta" data-id="element-16" />
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-17">
              {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-18">
                  <XCircle className="w-5 h-5 text-terracotta/60 flex-shrink-0 mt-1" data-id="element-19" />
                  <span className="text-warmgray" data-id="element-20">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}